<template>
  <div class="cate">
    <div class="cate-parent flex flex-row flex-wrap pointer">
      <div
        v-for="(item, index) in parentItem"
        :key="index"
        class="cate-item parent"
        :class="{
          active:
            item.laboratoryAbilityTypeId ===
            currentParent.laboratoryAbilityTypeId,
        }"
        @click="pItemClick(item)"
      >
        {{ item.laboratoryAbilityTypeName }}
      </div>
    </div>
    <div class="cate-child flex flex-row flex-wrap pointer">
      <div
        v-for="(item, index) in childItem[
          currentParent.laboratoryAbilityTypeId
        ]"
        :key="index"
        class="cate-item child"
        :class="{
          active:
            item.laboratoryAbilityTypeId ===
            currentChild.laboratoryAbilityTypeId,
        }"
        @click="cItemClick(item)"
      >
        {{ item.laboratoryAbilityTypeName }}
      </div>
    </div>
  </div>
</template>
<script>
import { abilityType } from "@/api/hall";
export default {
  data() {
    return {
      parentItem: [],
      childItem: {},
      currentParent: {},
      currentChild: {},
    };
  },
  created() {
    this.getType();
  },
  methods: {
    async getType(pid = 0) {
      const data = await this.$axios.get(abilityType, { pid });
      if (pid) {
        // 子类
        this.$set(this.childItem, pid, data);
      } else {
        // 首次打开页面
        this.parentItem = data;
        const { pId } = this.$route.query;
        if (pId) {
          const pIndex = data.findIndex(
            (item) => item.laboratoryAbilityTypeId === +pId
          );
          this.pItemClick(this.parentItem[pIndex]);
        } else {
          this.pItemClick(this.parentItem[0]);
        }
      }
    },
    // 父类点击
    pItemClick(item) {
      this.currentParent = item;
      this.currentChild = {};
      const id = item.laboratoryAbilityTypeId;
      if (!this.childItem[id]) this.getType(id);
      this.getList();
    },
    // 子类点击
    cItemClick(item) {
      this.currentChild = item;
      this.getList();
    },
    // 获取列表数据
    async getList() {
      this.$emit("typeClick", {
        firstTypeId: this.currentParent.laboratoryAbilityTypeId,
        secondTypeId: this.currentChild.laboratoryAbilityTypeId,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";
.cate {
  background: white;
  padding: 15px 15px 5px 15px;
  &-item {
    margin-right: 20px;
    margin-bottom: 10px;
    // font-size: 12px;
    &:hover,
    &.active {
      color: $theme-color;
    }
    &.parent {
      font-size: 15px;
      font-weight: bold;
    }
    &.child {
      border: 1px solid white;
      padding: 3px 10px;
    }
    &.child.active {
      border: 1px solid $theme-color;
      border-radius: 15px;
    }
  }
  &-parent {
    margin-bottom: 5px;
    padding-left: 10px;
  }
}
</style>
